
import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    CircularProgress,
    Tabs,
    Tab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import "./MapSiteToSupervisor.css"; // reuse the same CSS
import apiService from "../../utils/apiservice";



const MapSiteToCustomerEngineer = () => {
    // const [supervisors, setSupervisors] = useState([]);
    // const [selectedSupervisor, setSelectedSupervisor] = useState("");
    const [assignedSites, setAssignedSites] = useState([]);
    const [availableSites, setAvailableSites] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);

    // const [dialogOpen, setDialogOpen] = useState(false);
    // const [selectedSiteForTransfer, setSelectedSiteForTransfer] = useState(null);
    // const [newSupervisor, setNewSupervisor] = useState("");

    const API_URL = process.env.REACT_APP_API_DJANGO_URL;
    const token = localStorage.getItem("accessToken");
    const customerId = localStorage.getItem("customer_id");


    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [engineers, setEngineers] = useState([]);
    const [selectedEngineer, setSelectedEngineer] = useState("");

    // Reset page when switching tabs or changing the supervisor
    // useEffect(() => {
    //     setPage(0);
    // }, [tabValue, selectedSupervisor]);

    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const getConfig = () => ({
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data: {},
    });

    useEffect(() => {
        const fetchEngineers = async () => {
            try {
                if (!customerId) return;

                const res = await apiService.get(
                    `/api/get_customer_engineers/${customerId}/`,
                    { data: {} }
                );

                const engData = res.data.engineers.map((eng) => ({
                    id: eng.id,
                    user_id: eng.user_id,
                    first_name: eng.first_name,
                    last_name: eng.last_name,
                    assigned_sites: eng.assigned_sites || [],
                }));
                setEngineers(engData);

                // auto-select first engineer
                if (engData.length > 0) {
                    const firstEngineerId = engData[0].user_id;
                    setSelectedEngineer(String(firstEngineerId));
                   fetchSites(firstEngineerId, engData);
                }

            } catch (err) {
                toast.error("Failed to fetch engineers");
            }
        };

        fetchEngineers();
    }, [customerId]);

   const fetchSites = async (engineerId, engineerList = engineers) => {
        try {
            setLoading(true);

            // get all customer sites
            const siteRes = await axios.get(
                `${API_URL}/api/get_customer_sites/${customerId}/`,
                getConfig()
            );

            const allSites = siteRes.data.data.map((s) => ({
                id: s.site_id,
                name: s.name,
                asset_uuid: s.asset_id,
            }));

            // find selected engineer
           const selectedEng = engineerList.find(
    (eng) => String(eng.user_id) === String(engineerId)
);
            // assigned sites from engineer object
            const assigned = selectedEng?.assigned_sites?.map((s) => ({
                id: s.site_id,
                name: s.site_name,
                asset_uuid: s.site_id,
            })) || [];

            setAssignedSites(assigned);

            // available = all customer sites - assigned sites
            const assignedUUIDs = assigned.map((s) => s.asset_uuid);

            const available = allSites.filter(
                (site) => !assignedUUIDs.includes(site.asset_uuid)
            );

            setAvailableSites(available);

        } catch (err) {
            toast.error("Failed to fetch sites");
            setAssignedSites([]);
            setAvailableSites([]);
        } finally {
            setLoading(false);
        }
    };

    const handleEngineerChange = (e) => {
    const engineerId = e.target.value;
    setSelectedEngineer(engineerId);

    if (engineerId) {
        fetchSites(engineerId, engineers);
    }
};



    // const handleAction = (site, action) => {
    //     if (action === "assign") {
    //         assignSite(site);
    //     } else {
    //         // 🔥 OPEN DIALOG instead of API
    //         setSelectedSiteForTransfer(site);
    //         setDialogOpen(true);
    //     }
    // };

    const handleAction = (site, action) => {
    if (action === "assign") {
        assignSite(site);
    } else {
        unassignSite(site);
    }
};


    const assignSite = async (site) => {
        try {
            await axios.post(
                `${API_URL}/api/assign_site_to_engineer_customer/`,
                {
                    engineer_id: selectedEngineer,
                    asset_id: site.asset_uuid,
                },
                getConfig()
            );

            setAssignedSites([...assignedSites, site]);
            setAvailableSites(availableSites.filter((s) => s.id !== site.id));

            toast.success("Site assigned successfully");
        } catch {
            toast.error("Assign failed");
        }
    };


    const unassignSite = async (site) => {
    try {
        await axios.post(
            `${API_URL}/api/unassign_site_from_engineer_customer/`,
            {
                engineer_id: selectedEngineer,
                asset_id: site.asset_uuid,
            },
            getConfig()
        );

        toast.success("Site unassigned successfully");

        // update UI instantly
        setAssignedSites((prev) =>
            prev.filter((s) => s.id !== site.id)
        );

        setAvailableSites((prev) => [...prev, site]);

    } catch (err) {
        toast.error(err.response?.data?.error || "Unassign failed");
    }
};

    // const handleTransfer = async () => {
    //     if (!newSupervisor || !selectedSiteForTransfer) {
    //         toast.error("Please select a new supervisor");
    //         return;
    //     }

    //     try {
    //         await axios.post(

    //             `${API_URL}/api/unassign_site_from_engineer_customer/`,
    //             {
    //                 old_engineer_id: selectedEngineer,
    //                 new_engineer_id: newSupervisor,
    //                 asset_id: selectedSiteForTransfer.asset_uuid,
    //             },
    //             getConfig()
    //         );

    //         toast.success("Site transferred successfully");

    //         // ✅ Refresh data
    //         fetchSites(selectedSupervisor);

    //         // Close dialog
    //         setDialogOpen(false);
    //         setNewSupervisor("");
    //         setSelectedSiteForTransfer(null);

    //     } catch (err) {
    //         toast.error(err.response?.data?.error || "Transfer failed");
    //     }
    // };



    const getFilteredSites = () => {
        if (tabValue === 1) return assignedSites;
        if (tabValue === 2) return availableSites;
        return [...assignedSites, ...availableSites];
    };

    return (
        <Paper className="main-card-ui">
            <Box className="header-row">
                <TextField
                    select
                    label="Select Engineer"
                    value={selectedEngineer}
                    onChange={handleEngineerChange}
                    size="small"
                    className="device-select-input"
                >
                    {engineers.map((eng) => (
                        <MenuItem key={eng.id} value={String(eng.user_id)}>
                            {eng.first_name} {eng.last_name}
                        </MenuItem>
                    ))}
                </TextField>
                <Box className="badge-container">
                    <div className="status-badge assigned">Assigned: {assignedSites.length}</div>
                    <div className="status-badge available">Available: {availableSites.length}</div>
                </Box>
            </Box>

            <Box className="tabs-wrapper">
                <Tabs
                    value={tabValue}
                    onChange={(e, v) => setTabValue(v)}
                    centered
                    className="custom-tabs"
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    <Tab label="All" />
                    <Tab label="Assigned" />
                    <Tab label="Available" />
                </Tabs>
            </Box>

            <TableContainer className="table-container-ui orange-table">
                {loading ? (
                    <Box textAlign="center" p={5}><CircularProgress /></Box>
                ) : (
                    <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Site Name</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {getFilteredSites().length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2} align="center" style={{ padding: "20px", color: "#94a3b8" }}>
                                        No sites found.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                getFilteredSites().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((site) => (
                                        <TableRow key={site.id}>
                                            <TableCell align="center">{site.name}</TableCell>
                                            <TableCell align="center">
                                                {assignedSites.some((s) => s.id === site.id) ? (
                                                    <Button className="btn-unmap" onClick={() => handleAction(site, "unassign")}>Unassign</Button>
                                                ) : (
                                                    <Button className="btn-map" onClick={() => handleAction(site, "assign")}>Assign</Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                            )}
                        </TableBody>
                    </Table>
                )}

                {/* After </TableContainer> */}
                {!loading && getFilteredSites().length > 0 && (
                    <div className="pagination-bar">
                        <div className="rows-select">
                            Rows per page:
                            <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                            </select>
                        </div>
                        <div className="page-info">
                            {page * rowsPerPage + 1}-
                            {Math.min((page + 1) * rowsPerPage, getFilteredSites().length)} of {getFilteredSites().length}
                        </div>
                        <div className="page-arrows">
                            <button disabled={page === 0} onClick={() => setPage(page - 1)}>‹</button>
                            <button
                                disabled={(page + 1) * rowsPerPage >= getFilteredSites().length}
                                onClick={() => setPage(page + 1)}
                            >
                                ›
                            </button>
                        </div>
                    </div>
                )}
            </TableContainer>

            {/* <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Assign Site to New supervisors</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Select a new supervisor
                    </DialogContentText>

                    <Box sx={{ mt: 2 }}>
                        <TextField
                            select
                            fullWidth
                            label="Select New Supervisor"
                            value={newSupervisor}
                            onChange={(e) => setNewSupervisor(e.target.value)}
                        >
                            {supervisors
                                .filter((sup) => sup.id !== selectedSupervisor) // exclude current
                                .map((sup) => (
                                    <MenuItem key={sup.id} value={sup.id}>
                                        {sup.first_name} {sup.last_name}
                                    </MenuItem>
                                ))}
                        </TextField>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleTransfer}
                        disabled={!newSupervisor}
                    >
                        Assign New Supervisor
                    </Button>
                </DialogActions>
            </Dialog> */}

            <ToastContainer position="top-right" autoClose={2000} />

        </Paper>

    );
};

export default MapSiteToCustomerEngineer;









